import mapapalIcon from '../assets/brand/mapapal-icon.png'

export function BrandMark({ compact = false, inverse = false, iconOnly = false, href, onNavigate }: { compact?: boolean; inverse?: boolean; iconOnly?: boolean; href?: string; onNavigate?: () => void }) {
  const className = `brand-mark${compact ? ' brand-mark--compact' : ''}${inverse ? ' brand-mark--inverse' : ''}${iconOnly ? ' brand-mark--icon-only' : ''}`
  const content = (
    <>
      <img className="brand-mark__symbol" src={mapapalIcon} alt="" aria-hidden="true" />
      {iconOnly ? null : <span className="brand-mark__word">Mapapal<span>.com</span></span>}
    </>
  )
  return href ? (
    <a
      className={className}
      href={href}
      aria-label="Mapapal.com home"
      title="Go to Mapapal.com home"
      onClick={onNavigate ? (event) => { event.preventDefault(); onNavigate() } : undefined}
    >
      {content}
    </a>
  ) : <div className={className} aria-label="Mapapal.com">{content}</div>
}
